import "./Marquee.css";

/** A slow ticker of the brand words; the text is doubled so the loop is seamless. */
export default function Marquee({ text, tone = "dark" }: { text: string; tone?: "dark" | "light" }) {
  const items = text.split(" · ");
  const row = (
    <>
      {items.map((item, index) => (
        <span key={`${item}-${index}`} className="marquee-item">
          {item}
          <span className="marquee-dot" aria-hidden="true" />
        </span>
      ))}
    </>
  );
  return (
    <div className={`marquee marquee-${tone}`} aria-label={text}>
      <div className="marquee-track" aria-hidden="true">
        <div className="marquee-row">{row}</div>
        <div className="marquee-row">{row}</div>
      </div>
    </div>
  );
}
